import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';


// ----------------------------------------------------------------------

export default function ProductionLayout({ children }) {
  return (
    <>

       <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      
            <Box
              component="main"
              sx={{
                flexGrow: 1,
              
                 
              
              }}
            >
              {children}
            </Box>
      
          </Box>
    </>
  );
}

ProductionLayout.propTypes = {
  children: PropTypes.node,
};
